import { Component, BaseTLDetailComponent, AxiosResponse, GeneralTermService, EnumsService, EnumsFilter } from "../../../Infrastructure/CorBase/CoreBase";
import { PricelistService, PricelistFilter, TariffService } from "../../../Services/AccBase/AllAccServices";

	export default abstract class  PricelistDetailBase extends BaseTLDetailComponent {

		pricelistService: PricelistService = new PricelistService();
		protected tariffService: TariffService = new TariffService();
		protected generalTermService: GeneralTermService = new GeneralTermService();
		protected enumsService: EnumsService = new EnumsService();

		items: any[] = [];
		items2: any[] = [];
		items3: any[] = [];

		typeTariffs: any[] = [];
		typeTerms: any[] = [];
		typeEnums: any[] = [];

		formData = {
			id: 0,
			name: '',
			description: '',
			identifier: '',
			vat: '',
			isDaily: false,
			isFromTo: false,
			idTariff: 0,
			idGeneralTermsAndConditions: 0,
			idGeneralTermsAndConditionsName: '',
			idTariffName: '',
			idItemType: 0,
			idItemTypeName: '',
			priceDay: 0,
			priceMonth: 0,
			amount: 0,
			amountFrom: 0,
			amountTo: 0,
			unit: '',
			isDeleted: false
		};

		createdBase() {
			this.loadEnums();
		}

		loadEnums() {
			var filters = (this.$store.state.filterAll as Array<any>).filter((c: any) => c.name == "pricelistTable")[0];
			this.typeEnums = [];
			this.typeTariffs = [];
			this.typeTerms = [];

			this.tariffService.getAll().then(res => {
				this.items = res.data;
				for (var i = 0; i < this.items.length; i++) {
					if (this.typeTariffs.filter((c: any) => c.value == this.items[i].id).length == 0) {
						this.typeTariffs.push({ value: this.items[i].id, text: this.items[i].name, description: this.items[i].name });
					}
				}
				this.typeTariffs = this.typeTariffs.sort((a, b) => a.text.localeCompare(b.text));
				this.formData.idTariff = (filters.value as Array<any>).filter((c: any) => c.key == "idTariff")[0].value;
			});

			this.generalTermService.getAll().then(res => {
				this.items2 = res.data;
				for (var i = 0; i < this.items2.length; i++) {
					if (this.typeTerms.filter((c: any) => c.value == this.items2[i].id).length == 0) {
						this.typeTerms.push({ value: this.items2[i].id, text: this.items2[i].name, description: this.items2[i].name });
					}
				}
				this.typeTerms = this.typeTerms.sort((a, b) => a.text.localeCompare(b.text));
				this.formData.idGeneralTermsAndConditions = (filters.value as Array<any>).filter((c: any) => c.key == "idGeneralTermsAndConditions")[0].value;
				
			});


			let enumsFilter: EnumsFilter = new EnumsFilter(this.$store.state.idTenant, "ENU_ACC_DiskSPace",null,null);
			this.enumsService.getAllByFilter(enumsFilter).then(res => {
				this.items3 = res.data;
				for (var i = 0; i < this.items3.length; i++) {
					if (this.typeEnums.filter((c: any) => c.value == this.items3[i].id).length == 0) {
						this.typeEnums.push({ value: this.items3[i].id, text: this.items3[i].name, description: this.items3[i].name });
					}
				}
				this.typeEnums = this.typeEnums.sort((a, b) => a.text.localeCompare(b.text));
				this.formData.idItemType = this.typeEnums[0].value;

			});
		}


		protected doAction() {
			super.doCRUDActionWithInfoMessage(this.$t('pricelist.messageNew').toString(), this.$t('pricelist.messageEdit').toString(), this.$t('pricelist.messageDelete').toString());
		}

		protected fetchDataFromServer(): Promise<AxiosResponse<any>> {
			return this.pricelistService.getById(this.objectId);
		}

		protected fetchRefreshDataFromServer(): Promise<AxiosResponse<any>> {
			return super.NoCall()
		}

		protected refreshItems(items: any, refreshData: any): any {
			return items;
		}

		protected processResponse(response: AxiosResponse<any>): void {
			this.formData.id = response.data.id;
			this.formData.name = response.data.name;
			this.formData.description = response.data.description;

			this.formData.identifier = response.data.identifier;
			this.formData.vat = response.data.vat;
			this.formData.idTariff = response.data.idTariff;
			this.formData.idTariffName = response.data.idTariffName;
			this.formData.idItemType = response.data.idItemType;
			this.formData.idItemTypeName = response.data.idItemTypeName;
			this.formData.priceDay = response.data.priceDay;
			this.formData.priceMonth = response.data.priceMonth;
			this.formData.amount = response.data.amount;
			this.formData.amountFrom = response.data.amountFrom;
			this.formData.amountTo = response.data.amountTo;
			this.formData.unit = response.data.unit;
			this.formData.idGeneralTermsAndConditions = response.data.idGeneralTermsAndConditions;
			this.formData.idGeneralTermsAndConditionsName = response.data.idGeneralTermsAndConditionsName;
			this.formData.isDaily = this.formData.priceDay > 0;
			this.formData.isFromTo = this.formData.amount == 0;


		}

		protected afterCreate(response: AxiosResponse<any>): void {
			this.formData.id = response.data.id;
			this.formData.idTariffName = response.data.idTariffName;
			this.formData.idGeneralTermsAndConditionsName = response.data.idGeneralTermsAndConditionsName;
			this.formData.idItemTypeName = response.data.idItemTypeName;
		}

		protected updateObject(): Promise<AxiosResponse<any>> {
			if (this.formData.isDaily) {
				this.formData.priceMonth = 0;
			}
			else {
				this.formData.priceDay = 0;
			}

			if (this.formData.isFromTo) {
				this.formData.amount = 0;
			}
			else {
				this.formData.amountFrom = 0;
				this.formData.amountTo = 0;
			}
			return this.pricelistService.update(this.objectId, this.formData);
		}

		protected updateBase() {
			if (this.formData.isDaily) {
				this.formData.priceMonth = 0;
			}
			else {
				this.formData.priceDay = 0;
			}

			if (this.formData.isFromTo) {
				this.formData.amount = 0;
			}
			else {
				this.formData.amountFrom = 0;
				this.formData.amountTo = 0;
			}
			var result = this.pricelistService.update(this.objectId, this.formData).then(res => {
				if (res.data.isSuccess == false) {
					this.showAlertModalWithTitleAndContent(this.$t('global.titleError').toString(), res.data.errorMessage);
				}
				else {
					this.showAlertModalWithInfoMessage(this.$t('pricelist.messageEdit').toString());
					this.formIsInEditMode = false;
				//	this.styleFormDetail = false;
				}
			});

			return result;
		}

		protected createObject(): Promise<AxiosResponse<any>> {		
			
			return this.pricelistService.create(this.formData);
		}

		protected deleteObject(): Promise<AxiosResponse<any>> {
			return this.pricelistService.delete(this.objectId);
		}
		
		vIsCorrectName: boolean = true;
		vIsCorrectIdentifier: boolean = true;
		vIsCorrectVat: boolean = true;
		vIsCorrectUnit: boolean = true;

		vIsCorrectDaily: boolean = true;
		vIsCorrectMonthly: boolean = true;

		vIsCorrectAmount: boolean = true;
		vIsCorrectAmountTo: boolean = true;
		vIsCorrectAmountFrom: boolean = true;
	
		protected validateBase() {
			return !(this.vIsCorrectName && this.vIsCorrectIdentifier && this.vIsCorrectVat && this.vIsCorrectUnit && ((this.formData.isDaily && this.vIsCorrectDaily) || (!this.formData.isDaily && this.vIsCorrectMonthly))
				&& ((!this.formData.isFromTo && this.vIsCorrectAmount) || (this.formData.isFromTo && this.vIsCorrectAmountFrom && this.vIsCorrectAmountTo))


			);
		}
		
		protected isCorrectNameBase(value: any) {
			this.vIsCorrectName = value;
		}

		protected isCorrectIdentifierBase(value: any) {
			this.vIsCorrectIdentifier = value;
		}

		protected isCorrectVarBase(value: any) {
			this.vIsCorrectVat = value;
		}

		protected isCorrectUnitBase(value: any) {
			this.vIsCorrectUnit = value;
		}

		protected isCorrectDailyBase(value: any) {
			this.vIsCorrectDaily = value;
		}

		protected isCorrectMonthlyBase(value: any) {
			this.vIsCorrectMonthly = value;
		}

		protected isCorrectAmountBase(value: any) {
			this.vIsCorrectAmount = value;
		}
		protected isCorrectAmountToBase(value: any) {
			this.vIsCorrectAmountTo = value;
		}
		protected isCorrectAmountFromBase(value: any) {
			this.vIsCorrectAmountFrom = value;
		}
	
	}
